export const notConfiguredContainerStyles =
   'py-8 rounded-2xl border flex flex-col gap-3'
export const notConfiguredInnerStyles = 'flex justify-center items-center gap-2'
export const notConfiguredTextContainerStyles = 'flex flex-col gap-2'
export const notConfiguredTitleStyles = 'text-sm-medium'
